export default
function (ngModule) {
    ngModule.directive('contentStreamTags', function() {
        'use strict';
        return {
            restrict: 'E',
            replace: true,
            scope: {
                document: '=',
                activeTagName: '='
            },
            template: require('./content-stream-tags.html'),
            controller: 'contentStreamTagsController'
        };
    })
    .controller('contentStreamTagsController', ['$scope', 'TagService', 'DialogService', 'translationService', '$log', 'ContentBehaviorService', 'AnalyticsService', function contentStreamTagsController($scope, TagService, DialogService, translationService, $log, ContentBehaviorService, AnalyticsService) {
        /**
         * Responsible for determining if the current tag should be displayed as active or inactive
         * @param currentTagName The current tag name we are checking to see if it should be active or inactive
         * @returns {boolean} Return true if the tag should be displayed as active.  Return false if the tag should be displayed as inactive
         */

        /**
         * Preventing the empty tag bug. Extra steps made to check for blank tags.
         */
        angular.forEach($scope.document.tags, function(tag, count) {
            if(tag === null || tag === '' || !tag) {
                $scope.document.tags.splice(count, 1);
            }
        });

        $scope.isActiveTagName = function isActiveTagName(currentTagName) {
            var isActive = false;

            if(!$scope.activeTagName) {
                // The default view for tags is to display the tag as active
                // Since there was not an active tag name provided we are handling setting the defualt properly here
                // This is need to allow regular content stream documents to display as active
                // It is only the tag results view that needs to worry about differentiating between active and inactive
                isActive = true;
            } else if($scope.activeTagName === currentTagName) {
                isActive = true;
            }
            return isActive;
        };

        var sourceDetail,
            isPremium,
            documentId,
            url,
            properties;

        /**
         * Responsible for removing the provided tag from the provided document.
         * @param documentId The id of the document that we are removing the tag from.
         * @param selectedTag The tag that we are removing from the document.
         */
        $scope.tagRemove = function tagRemove(documentId, selectedTag){
            var tags = $scope.document.tags || [];

            AnalyticsService.removeTagFromDocument(selectedTag, $scope.document, ContentBehaviorService.isHostedContentProvider($scope.document));

            for (var i = 0; i < tags.length; i++) {
                if (tags[i] === selectedTag) {
                    tags.splice(i, 1);
                    break;
                }
            }

            TagService.untagDocument(documentId, {name: selectedTag}).then(function(ret) {
                if(ret.status !== 200) {
                    $scope.document.tags.push(selectedTag);
                    var str = 'Failed to remove tag \"[[entityName]]\".',
                        param = { entityName: selectedTag },
                        errorMessage = translationService.getLocalizedString(str, param);
                    DialogService.flashError(errorMessage);
                }
            });
        };
    }]);
}



// WEBPACK FOOTER //
// ./source/components/content-stream-tags/content-stream-tags.js